export default "__VITE_ASSET__5efd502c__"